export const IN_PLAY_DEFAULT_FILTERS = ['all', 'highlights'];
export const MINUTE_SYMBOL = '’';
export const SCORE_SEPARATOR = '-';

export const InPlayFilters = {
  ALL: 'all',
  HIGHLIGHTS: 'highlights',
  NOW: 'now'
} as const;
